/* Drag&Drop collection/B2B grid view switcher. Standalone and scoped; no card/cart rewrites. */
(function () {
  'use strict';
  if (window.DDResponsiveGridSwitcher20261030) return;
  window.DDResponsiveGridSwitcher20261030 = true;

  var GRID_SELECTOR = '[data-ddnn-grid], [data-dd-designer-grid], #ddcGrid, #ddColGrid, #product-grid.product-grid, #product-grid ul.product-grid, .template-search__results ul.product-grid, .ddlc__grid';
  var B2B_GRID_SELECTOR = '.ddrfq [data-rfq-grid], .ddrfq [data-rfq-verified-grid]';
  var labels = ['Tek sütun', 'İki sütun', 'Üç sütun', 'Dört sütun', 'Beş sütun', 'Altı sütun'];
  var syncing = false;
  var syncQueued = false;

  function breakpoint() {
    var w = window.innerWidth || document.documentElement.clientWidth || 1200;
    return w < 750 ? 'mobile' : w < 990 ? 'tablet' : 'desktop';
  }
  function maxColumns() {
    var mode = breakpoint();
    return mode === 'mobile' ? 2 : mode === 'tablet' ? 3 : 6;
  }
  function defaultColumns() {
    var mode = breakpoint();
    return mode === 'mobile' ? 2 : mode === 'tablet' ? 3 : 4;
  }
  function key(kind) { return 'dd.gridview.' + kind + '.' + breakpoint() + '.v1'; }
  function stored(kind) {
    var value = null;
    try { value = window.localStorage.getItem(key(kind)); } catch (e) { /* Privacy mode */ }
    var n = Number(value);
    return Number.isInteger(n) && n >= 1 && n <= maxColumns() ? n : defaultColumns();
  }
  function save(kind, n) {
    try { window.localStorage.setItem(key(kind), String(n)); } catch (e) { /* Privacy mode */ }
  }
  function applicableGrid(node) {
    return node && node.nodeType === 1 && !node.closest('[hidden]') && !node.closest('.ddrfq__detail-overlay') && !!node.children.length;
  }
  function makeSwitcher(kind) {
    var holder = document.createElement('div');
    holder.className = 'dd-grid-view';
    holder.dataset.ddGridViewSwitcher = kind;
    holder.setAttribute('role', 'group');
    holder.setAttribute('aria-label', 'Ürün kartı sütun sayısı');
    var title = document.createElement('span');
    title.className = 'dd-grid-view__title';
    title.textContent = 'Görünüm';
    holder.appendChild(title);
    var options = document.createElement('div');
    options.className = 'dd-grid-view__options';
    for (var col = 1; col <= 6; col++) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'dd-grid-view__button';
      button.dataset.ddViewCount = String(col);
      button.dataset.ddViewMode = kind;
      button.setAttribute('aria-label', labels[col - 1] + ' görünüm');
      button.setAttribute('title', labels[col - 1]);
      button.setAttribute('aria-pressed', 'false');
      if (col > 3) button.classList.add('dd-grid-view__desktop-only');
      if (col > 2) button.classList.add('dd-grid-view__hide-mobile');
      var icon = document.createElement('span');
      icon.className = 'dd-grid-view__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.style.setProperty('--dd-icon-columns', String(col));
      for (var j = 0; j < col; j++) {
        var cell = document.createElement('span');
        cell.className = 'dd-grid-view__icon-cell';
        icon.appendChild(cell);
      }
      button.appendChild(icon);
      options.appendChild(button);
    }
    holder.appendChild(options);
    return holder;
  }
  function apply(kind, count, persist) {
    var columns = Math.max(1, Math.min(maxColumns(), Number(count) || defaultColumns()));
    if (persist) save(kind, columns);
    document.querySelectorAll('[data-dd-grid-view-grid="' + kind + '"]').forEach(function (grid) {
      grid.dataset.ddViewColumns = String(columns);
      grid.style.setProperty('--dd-view-columns', String(columns));
      // Update actual layout, not just the active icon; overrides old section media rules.
      grid.style.setProperty('grid-template-columns', 'repeat(' + columns + ', minmax(0, 1fr))', 'important');
      grid.style.setProperty('display', 'grid', 'important');
      grid.classList.add('dd-grid-view__grid');
      grid.querySelectorAll('.ddnn-grid-promo').forEach(function(promo) {
        promo.style.setProperty('grid-column', columns === 1 ? '1 / -1' : 'span 2', 'important');
      });
    });
    document.querySelectorAll('[data-dd-grid-view-switcher="' + kind + '"] [data-dd-view-count]').forEach(function (button) {
      var active = Number(button.dataset.ddViewCount) === columns;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  function registerGrid(grid, kind, withSwitcher) {
    if (!applicableGrid(grid)) return;
    grid.dataset.ddGridViewGrid = kind;
    if (withSwitcher && !grid.dataset.ddGridViewMounted) {
      var surface = makeSwitcher(kind);
      grid.parentNode.insertBefore(surface, grid);
      grid.dataset.ddGridViewMounted = '1';
    }
  }
  function mount() {
    if (syncing) return;
    syncing = true;
    try {
      var isCollection = document.body && (document.body.classList.contains('template-collection') ||
          document.body.classList.contains('template-search') ||
          /\/(collections|search)(\/|\?|$)/.test(window.location.pathname));
      if (isCollection) {
        document.querySelectorAll(GRID_SELECTOR).forEach(function (grid) {
          if (!grid.closest('.ddrfq')) registerGrid(grid, 'collection', true);
        });
      }
      var b2bGrid = document.querySelector(B2B_GRID_SELECTOR);
      if (b2bGrid && applicableGrid(b2bGrid)) {
        document.querySelectorAll(B2B_GRID_SELECTOR).forEach(function (grid) {
          registerGrid(grid, 'b2b', grid === b2bGrid);
        });
      }
      apply('collection', stored('collection'), false);
      apply('b2b', stored('b2b'), false);
    } finally { syncing = false; }
  }
  function queueMount() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(function () {
      syncQueued = false;
      mount();
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dd-view-count][data-dd-view-mode]');
    if (!button) return;
    event.preventDefault();
    var kind = button.dataset.ddViewMode;
    var n = Number(button.dataset.ddViewCount);
    if (kind !== 'collection' && kind !== 'b2b') return;
    if (!Number.isInteger(n) || n < 1 || n > maxColumns()) return;
    apply(kind, n, true);
  });
  document.addEventListener('shopify:section:load', queueMount);
  document.addEventListener('dd:collection:rendered', queueMount);
  window.addEventListener('pageshow', queueMount);
  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      apply('collection', stored('collection'), false);
      apply('b2b', stored('b2b'), false);
    }, 120);
  }, { passive: true });
  function observe() {
    if (!document.body || !window.MutationObserver) return;
    var observer = new MutationObserver(function (records) {
      var changed = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, function (node) {
          if (node.nodeType !== 1 || node.closest('[data-dd-grid-view-switcher]')) return false;
          return node.matches && (node.matches(GRID_SELECTOR) || node.matches(B2B_GRID_SELECTOR) ||
            node.querySelector && (node.querySelector(GRID_SELECTOR) || node.querySelector(B2B_GRID_SELECTOR)));
        });
      });
      if (changed) queueMount();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(); observe(); }, { once: true });
  } else { mount(); observe(); }
})();
